module.exports = "<p>{{test2}}</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/partials/test.html
// module id = 505
// module chunks = 0